import tw, { styled } from 'twin.macro';

export const StyledContainer = styled.div`
  ${tw`flex gap-2`}
`;
